import { of as observableOf } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import * as _ from 'lodash';

import { Storage } from '../storage/storage.service';
import { LoggerService } from '@services/logger/logger.service';
//
// export interface State {
// 	[key: string]: any;
// }
// export interface StateStore {
// 	[name: string]: State;
// }

@Injectable()
export class StateService {
	key = `${environment.storageTokenLocation}-store`;
	store = {};

	constructor(private storage: Storage, private log: LoggerService) {
		this.createTree();
	}

	createTree() {
		this.storage.get(this.key).subscribe(res => {
			this.log.debug('State', res);
		});
	}

	save(loc: string, val) {
		const saveLocal = () => _.set(this.store, loc, val);
		if (environment.keepStates)
			this.storage.set(loc, val).subscribe(res => saveLocal());
		else saveLocal();
	}

	read(loc) {
		const readLocal = () => _.get(this.store, loc);
		return environment.keepStates
			? this.storage.get(loc)
			: observableOf(readLocal());
	}
}
